import React, { useState, useRef } from "react";
import {
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import jsPDF from "jspdf";
import "jspdf-autotable";

const ExportDropdown = ({ data, onlyCsv }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  // CSV Export
  const handleExportCSV = () => {
    const headers = ["Name", "Contact", "Type", "Department", "Tags"];
    const csvRows = [headers.join(",")];

    data.forEach((row) => {
      const rowData = [
        row.name,
        row.contacts?.name || "",
        row.assetType?.name || "",
        row.contacts?.department || "",
        row.assetTag || ""
      ];
      csvRows.push(rowData.map((val) => `"${val}"`).join(","));
    });

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "assets.csv";
    a.click();
    window.URL.revokeObjectURL(url);
    handleClose();
  };

  // PDF Export
  const handleExportPDF = () => {
    const doc = new jsPDF();
    const headers = [["Name", "Contact", "Type", "Department", "Tags"]];
    const rows = data.map((row) => [
      row.name,
      row.contacts?.name || "",
      row.assetType?.name || "",
      row.contacts?.department || "",
      row.assetTag || ""
    ]);
    doc.autoTable({
      head: headers,
      body: rows,
      styles: { fontSize: 9 },
    });
    doc.save("assets.pdf");
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<DownloadIcon />}
        onClick={handleClick}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleExportCSV}>Export CSV</MenuItem>
        {!onlyCsv && <MenuItem onClick={handleExportPDF}>Export PDF</MenuItem>}
      </Menu>
    </>
  );
};

export default ExportDropdown;
